<app-section-header
    itemsName="deposit"
    [searchDisabled]="!projectDepositsSettingsService.totalItems()"
    [totalItems]="projectDepositsSettingsService.totalItems()"
    (search)="projectDepositsSettingsService.searchDeposits($event)" />

<div class="flex-1 flex flex-col min-h-0 overflow-y-auto overflow-x-hidden">
    @for (section of projectDepositsSettingsService.depositSections(); track section.title) {
        @if (section.isLoading) {
            <app-loading class="my-4" />
        }
        <app-expansion-panel
            class="mt-3"
            [isExpanded]="!!section.deposits?.length">
            <p
                class="!m-0 text-xl"
                header>
                {{ section.title | transloco }} ({{ section.totalItems }})
            </p>

            <div
                class="flex-1 overflow-x-auto min-h-0"
                content>
                <app-project-deposit-section [dataSection]="section" />
            </div>
        </app-expansion-panel>
    }
</div>
